export const GET_CANDIDATES = "GET_CANDIDATES"
export const GET_CANDIDATE_LIST_ITEMS = "GET_CANDIDATE_LIST_ITEMS"
export const GET_CANDIDATE = "GET_CANDIDATE"
export const GET_REJECT_REASON = "GET_REJECT_REASON"


// WEBPACK FOOTER //
// ./src/actionTypes/candidate.js